import React from 'react';
import {OrderSummaryDataHook} from '../../OrderSummary';
import {useControllerProps} from '../../../../ControllerContext';
import {ShippingDestination} from '../ShippingDestination/ShippingDestination';
import {useTranslation} from '@wix/yoshi-flow-editor';
import type {TFunction} from '@wix/wix-i18n-config';

const ShippingDestinationAndShippingRates = () => {
  const {addGlobalEAttributesForCart} = useControllerProps().cartStore;
  const {t} = useTranslation();
  const {shouldDisplayDeliveryError, isPickup, isPickupPoint, isPickupPointsBmPhase1Active} =
    useControllerProps().orderStore;
  const {cart} = useControllerProps().cartStore;

  const displayPrice = !shouldDisplayDeliveryError;
  return (
    <dl>
      <dt>
        <div data-hook={OrderSummaryDataHook.TotalShippingShippingDestinationWithTitle}>
          <span data-hook={OrderSummaryDataHook.TotalShippingTitle}>
            {getTotalShippingTitle({t, isPickup, isPickupPoint, isPickupPointsBmPhase1Active})}
          </span>
          &nbsp;
          <ShippingDestination dataHook={OrderSummaryDataHook.ShippingDestinationRoot} />
        </div>
      </dt>

      {displayPrice && addGlobalEAttributesForCart && (
        <dd
          data-hook={OrderSummaryDataHook.TotalShippingEstimatedShipping}
          data-wix-total-shipping-estimated-shipping={OrderSummaryDataHook.TotalShippingEstimatedShipping}>
          {cart.convertedTotals.shipping > 0 ? cart.convertedTotals.formattedShipping : t('cart.free_shipping')}
        </dd>
      )}

      {displayPrice && !addGlobalEAttributesForCart && (
        <dd data-hook={OrderSummaryDataHook.TotalShippingEstimatedShipping}>
          {cart.convertedTotals.shipping > 0 ? cart.convertedTotals.formattedShipping : t('cart.free_shipping')}
        </dd>
      )}
    </dl>
  );
};

export const TotalShipping = () => {
  const {isEstimatedDestinationIsShippable} = useControllerProps().orderStore;

  return (
    <div data-hook={OrderSummaryDataHook.TotalShippingRoot}>
      {isEstimatedDestinationIsShippable ? (
        <ShippingDestinationAndShippingRates />
      ) : (
        <dt>
          <ShippingDestination dataHook={OrderSummaryDataHook.ShippingDestinationRoot} />
        </dt>
      )}
    </div>
  );
};

function getTotalShippingTitle({
  t,
  isPickup,
  isPickupPoint,
  isPickupPointsBmPhase1Active,
}: {
  t: TFunction;
  isPickup: boolean;
  isPickupPoint: boolean;
  isPickupPointsBmPhase1Active: boolean;
}) {
  if (isPickupPointsBmPhase1Active && isPickupPoint) {
    return t('cart.estimated_shipping');
  }
  return isPickup ? t('cart.estimated_pickup') : t('cart.estimated_shipping');
}
